import { useEffect, useState } from 'react'
import axios from 'axios'
import { toast } from "react-toastify";
import { useAuth } from '../auth';
import { WalletLogsTable }  from './table/WalletLogsTable';
import { Filter } from './Filter'
import { KTCard } from '../../../_metronic/helpers'
import { getTransactionType, getConsumptionType } from '../../../_metronic/helpers/utils';

const Index = () => {
    const { haveAccess, currentUser } = useAuth()
    const [walletData, setWalletData] = useState({})
    const [isLoading, setLoading] = useState(false);
    const [pageSize, setPageSize] = useState(100)
    const [page, setPage] = useState(1)
    const [sort, setSort] = useState({ key: 'created_at', order: 'desc' })
    const [filter, setFilter] = useState({})

    const getWalletTable = () => {
    setLoading(true)
    axios.get(`${process.env.REACT_APP_API_V3_URL}/wallets/all-logs?page_size=${pageSize}&page=${page}&sort=${sort.key}&dir=${sort.order}${filter?.key ? `&${filter?.key}=${filter?.value}&entry_type=${filter?.entry_type}` : ''}`).then((response) => {
        setWalletData(response.data)
        setLoading(false)
    }).catch((err) => {
        setLoading(false)
        if (err && err.response && err.response?.data && err.response?.data?.message) {
            toast.error(err.response.data.message);
        } else {
            toast.error("Technical Error, Please Try Again");
        }
    })
}

useEffect(() => {
    getWalletTable()
}, [page, pageSize, sort, filter])

    return (
        <>
            {(haveAccess(currentUser, 'wallets_list')) ?
            <KTCard>
                    <div className="d-flex justify-content-end pt-6 px-6">
                        <Filter
                            filter={filter}
                            setFilter={setFilter}
                            getConsumptionType={getConsumptionType}
                            getTransactionType={getTransactionType}
                        />
                    </div>
                <WalletLogsTable
                    walletData={walletData}
                    pageSize={pageSize}
                    setPageSize={setPageSize}
                    page={page}
                    setPage={setPage}
                    isLoading={isLoading}
                    setSort={setSort}
                    sort={sort}
                    getConsumptionType={getConsumptionType}
                    getTransactionType={getTransactionType}
                />
            </KTCard>
            :
            <div className='d-flex text-center w-100 align-content-center justify-content-center' style={{ height: '70vh', alignItems: 'center', fontSize: '42px', color: '#ffa049', background: 'rgba(0,0,0,0.1)' }}>
                You do not have permission to view wallet Logs
            </div>
        }
        </>
    )
}

export default Index